<template>
  <div class="createPlayStep">
    <div class="backBox">
      <img
        class="pointer"
        @click="clickLocalStep()"
        src="@/assets/thdImg/pages/back.svg"
        alt=""
      />
      <span class="backBox_name">{{ activityData.name }}</span>
    </div>
    <div class="formBox">
      <!-- 步骤条 -->
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="1">
          <el-step title="活动模板"></el-step>
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>
      <!--  活动条件表单部分 -->
      <div class="secondstep">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          class="backgroundForm"
          label-width="120px"
        >
          <el-form-item label="活动名称:" prop="activityName">
            <el-input
              v-model="ruleForm.activityName"
              maxlength="50"
              show-word-limit
              placeholder="请输入活动名称"
              style="width: 340px"
            ></el-input>
          </el-form-item>
          <el-form-item label="活动时间:" prop="activityTimeValue">
            <div class="my_select_time">
              <el-date-picker
                v-model="activityTimeValue"
                type="datetimerange"
                class="rangeTime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                ref="timeBox"
                @change="activityTimeChange"
                style="width: 340px; font-size: 12px"
                :picker-options="pickerOptionsValue"
                :default-time="defaultTime"
              >
              </el-date-picker>
              <i
                class="el-icon-circle-close date_icon1"
                @click="activityTimeValue = []"
              ></i>
              <img
                src="@/assets/images/select_date.svg"
                alt=""
                class="date_icon2"
              />
            </div>
            <span class="lastTime" style="color: #666">
              活动持续 <span style="color: #2670fb">{{ timeDay }}</span> 天
              <span style="color: #2670fb">{{ timeOut }}</span> 小时
              <el-tooltip
                class="item"
                effect="light"
                content="活动有效期不可超过订购有效期"
                placement="bottom"
              >
                <el-button type="text" style="width: 35px">
                  <i class="el-icon-question"></i>
                </el-button>
              </el-tooltip>
            </span>
          </el-form-item>
          <el-form-item label="活动对象:" required>
            <el-radio-group
              v-model="ruleForm.activityObject"
              :disabled="isStartEdit"
              @change="handleActivityObj"
              style="margin-right: 16px"
            >
              <el-radio :label="0">不限</el-radio>
              <el-radio :label="1">指定身份</el-radio>
              <el-radio :label="2" disabled>指定人群</el-radio>
            </el-radio-group>
            <el-popover
              placement="right-start"
              trigger="hover"
              content="您不满足使用该功能的条件，请联系专属客服了解~"
            >
              <el-button slot="reference" disabled>{{
                peopleList.length == 0
                  ? "选择人群"
                  : `已选${peopleList.length}个`
              }}</el-button>
            </el-popover>
          </el-form-item>
          <el-form-item
            label="新老客户:"
            required
            v-if="ruleForm.activityObject == '1'"
          >
            <el-radio-group
              v-model="ruleForm.newOldCustomer"
              :disabled="isStartEdit"
            >
              <el-radio :label="0">不限</el-radio>
              <el-radio :label="1">新客</el-radio>
              <el-radio :label="2">老客</el-radio>
            </el-radio-group>
            <el-tooltip effect="dark" placement="top-start">
              <div slot="content">
                1、历史订单中已完成订单的订单数为0则定义为新客<br />2、历史订单中已完成订单的订单数≥1则定义为新客
              </div>
              <div
                class="cursorPointer"
                style="
                  display: inline-block;
                  margin-left: 16px;
                  font-size: 12px;
                  color: #999;
                "
              >
                <span>新老客说明</span>
                <i class="el-icon-question"></i>
              </div>
            </el-tooltip>
          </el-form-item>
          <el-form-item
            label="参与对象:"
            prop="partner"
            v-if="ruleForm.activityObject == '1'"
          >
            <!-- <el-checkbox-group
              v-model="ruleForm.allowLevel"
              @change="checkListchange"
              :disabled="isStartEdit"
            >
              <el-checkbox label="-1" name="partner">全部</el-checkbox>
              <el-checkbox
                v-for="(item, index) in levelList"
                :key="index"
                :label="item.level"
                name="partner"
                :disabled="ruleForm.allowLevel == -1"
                >{{ item.name }}</el-checkbox
              >
            </el-checkbox-group> -->
            <el-checkbox-group
              v-model="ruleForm.partner"
              @change="checkListchange"
              :disabled="activityData.isStart || backgroundOpacity"
            >
              <el-checkbox label="-1" name="partner">全部</el-checkbox>
              <el-checkbox
                v-for="item in levelList"
                :key="item.value"
                :label="item.value"
                name="partner"
                :disabled="ruleForm.partner.includes('-1')"
                >{{ item.name }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>

          <el-form-item
            label="入会时间:"
            v-if="ruleForm.activityObject == '1' && ruleForm.allowLevel != 0"
          >
          <el-date-picker
            v-model="ruleForm.membershipTime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            start-placeholder="开始日期"
            type="datetime"
            :disabled="nowType == 'look' || (nowType == 'edit' && activityData.status == 2)"
            placeholder="选择日期时间">
          </el-date-picker>
          之后成为会员的用户可参与活动
          </el-form-item>

          <el-form-item label="领取时间:" required>
            <div>
              <span> 用户生日前 </span>
              <el-input
                v-model="ruleForm.birthBeforeDay"
                @input="ruleForm.birthBeforeDay = getNumberData($event, 0, 0)"
                style="width: 70px"
                placeholder="请输入"
                :disabled="isStartEdit"
              ></el-input>
              <span> 天到后 </span>
              <el-input
                v-model="ruleForm.birthAfterDay"
                @input="ruleForm.birthAfterDay = getNumberData($event, 0, 0)"
                style="width: 70px"
                placeholder="请输入"
                :disabled="isStartEdit"
              ></el-input>
              <span> 天可领取奖品</span>
            </div>
          </el-form-item>
          <el-form-item required>
            <span slot="label" class="set">奖品设置:</span>
            <div class="setting-tip">
              <div>
                <span
                  >1、奖品展示图片建议尺寸：300*300像素，图片大小不能超过300K，类型：JPG、PNG</span
                >
              </div>
              <div class="setting-tip-last-wrap">
                <span
                  >2、设置多个奖品时，生日会员可同时领取多个奖品，当设置不同份数奖品时，实际领取情况说明：<br /><span
                    class="setting-tip-red"
                    >例：设置积分发放份数为100份，实物发放份数为20份。则活动开始后前20名领取的会员可同时收到两份奖品，之后参与的80人只能收到积分奖品</span
                  ></span
                >
              </div>
            </div>
            <div class="setting-radio">
              <el-radio
                v-model="ruleForm.settingType"
                :label="2"
                :disabled="activityData.isStart || backgroundOpacity"
                >统一设置</el-radio
              >
              <el-radio
                v-model="ruleForm.settingType"
                :label="1"
                :disabled="activityData.isStart || backgroundOpacity"
                >按等级设置</el-radio
              >
            </div>
            <div v-if="ruleForm.settingType == 1">
              <div class="setting-level">
                <div
                  :class="[
                    'setting-level-item',
                    { 'setting-level-item__active': levelIndex == index },
                  ]"
                  v-for="(item, index) in getChooseLevel"
                  :key="index"
                  @click="levelClick(index)"
                >
                  <span>{{ item.name }}</span>
                </div>
              </div>
              <template v-for="(item, index) in prizeSettingListLevel">
                <div :key="index">
                  <el-table
                    v-if="levelIndex == index"
                    :data="item.settingList"
                    style="
                      width: 1040px;
                      border: 1px solid #f0f0f0;
                      overflow: visible;
                    "
                    :header-cell-style="{
                      background: '#fafafa',
                      'text-align': 'center',
                    }"
                    :cell-style="{
                      'text-align': 'center',
                      overflow: 'visible',
                    }"
                  >
                    <el-table-column prop="date" label="序号" width="110">
                      <template slot-scope="scope">
                        <span>{{ scope.$index + 1 }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="奖品类型">
                      <template slot-scope="scope">
                        <div v-if="backgroundOpacity || activityData.isStart">
                          <span
                            style="color: #909399"
                            v-if="scope.row.prizeType == 3"
                            >{{ scope.row.title }}</span
                          >
                          <span
                            style="color: #909399"
                            v-else-if="scope.row.prizeType"
                            >{{ scope.row.prizeType | prizeType }}</span
                          >
                          <span v-else style="color: #909399">选择奖品</span>
                        </div>
                        <div v-else>
                          <div>
                            <el-button
                              style="width: auto"
                              key="2"
                              :disabled="isStartEdit"
                              type="text"
                              v-if="scope.row.prizeType"
                              @click="centerVis2(scope)"
                              >{{ scope.row.prizeType | prizeType }}</el-button
                            >
                            <el-button
                                v-else
                                key="3"
                                @click="centerVis2(scope)"
                                type="text"
                                style="width: auto"
                              >选择奖品</el-button
                            >
                          </div>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="name"
                      label="奖品名称"
                      min-width="200px"
                    >
                      <template slot-scope="scope">
                        <div>
                          <span
                            v-if="
                              scope.row.prizeType == 3 ||
                              scope.row.prizeType == 10
                            "
                            style="width: auto; white-space: normal"
                          >
                            {{ scope.row.title }}
                          </span>
                          <span v-else-if="scope.row.prizeType">{{
                            scope.row.prizeType | prizeType
                          }}</span>
                        </div>
                      </template>
                    </el-table-column>

                    <el-table-column label="值" width="80" prop="price">
                    </el-table-column>

                    <el-table-column label="奖品总份数" width="180">
                      <!-- :disabled="isStartEdit" -->
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.prizeCount"
                          placeholder="请输入"
                       
                          @input="
                            scope.row.prizeCount = getNumberData(
                              $event,
                              0,
                              1,
                              100
                            )
                          "
                        ></el-input>
                      </template>
                    </el-table-column>

                    <el-table-column label="奖品展示图片" width="170">
                      <template slot-scope="scope">
                        <el-image
                          class="elImg"
                          :src="scope.row.logo"
                          fit="contain"
                          style="
                            width: 40px;
                            height: 40px;
                            background: #d9d9d9;
                            border-radius: 4px 4px 4px 4px;
                          "
                        >
                          <div slot="error" class="image-slot"></div>
                        </el-image>
                      </template>
                    </el-table-column>

                    <el-table-column label="">
                      <template slot-scope="scope">
                        <!-- <div
                          v-if="backgroundOpacity || activityData.isStart"
                          class="btn-wrap"
                        >
                          <div style="color: #909399; margin-right: 10px">
                            上传图片
                          </div>
                          <div
                            style="color: #909399"
                            v-if="scope.row.prizeType != 3"
                          >
                            重置
                          </div>
                        </div> -->
                        <div class="btn-wrap">
                          <!-- <el-upload
                            :disabled="activityData.isStart"
                            class="upload"
                            action="/api/image/upload"
                            :show-file-list="false"
                            :before-upload="beforeUpload3"
                            :on-success="
                              (file) => {
                                return handleUpload3(file, scope);
                              }
                            "
                          >
                            <el-button       
                             type="text"
                             class="text-btn"
                              style="margin-right: 10px">
                              上传图片
                            </el-button>
                          </el-upload>
                          <el-button
                            v-if="scope.row.prizeType != 3"
                             type="text"
                             class="text-btn"
                             @click="cleanData(scope.row)"
                            >重置</el-button
                          > -->
                        </div>
                        <div
                          class="del_box"
                          v-if="!activityData.isStart && !backgroundOpacity"
                        >
                          <div
                            class="delQx"
                            @click="deleteSetting(scope.$index, item)"
                          >
                            <img src="@/assets/images/btn_del.svg" alt="" />
                          </div>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-button
                    v-if="
                      levelIndex == index &&
                      !activityData.isStart &&
                      !backgroundOpacity
                    "
                    @click="addSetting(item)"
                    type="primary"
                    style="margin-top: 8px; width: auto"
                  >
                    添加奖项（{{ item.settingList.length }}/4）
                  </el-button>
                </div>
              </template>
            </div>
            <div v-else>
              <el-table
                :data="prizeSettingList"
                style="
                  width: 1040px;
                  border: 1px solid #f0f0f0;
                  overflow: visible;
                "
                :header-cell-style="{
                  background: '#fafafa',
                  'text-align': 'center',
                }"
                :cell-style="{ 'text-align': 'center', overflow: 'visible' }"
              >
                <el-table-column prop="date" label="序号" width="110">
                  <template slot-scope="scope">
                    <span>{{ scope.$index + 1 }}</span>
                  </template>
                </el-table-column>
                <!-- 没问题 -->
                <el-table-column label="奖品类型">
                  <template slot-scope="scope">
                    <div v-if="backgroundOpacity || activityData.isStart">
                      <span
                        style="color: #909399"
                        v-if="scope.row.prizeType == 3"
                        >{{ scope.row.title }}</span
                      >
                      <span
                        style="color: #909399"
                        v-else-if="scope.row.prizeType"
                        >{{ scope.row.prizeType | prizeType }}</span
                      >
                      <span v-else style="color: #909399">选择奖品</span>
                    </div>
                    <div v-else>
                      <div>
                        <el-button
                          style="width: auto"
                          key="2"
                          :disabled="isStartEdit"
                          type="text"
                          v-if="scope.row.prizeType"
                          @click="centerVis(scope)"
                          >{{ scope.row.prizeType | prizeType }}</el-button
                        >
                        <el-button
                          v-else
                          style="width: auto"
                          key="3"
                          @click="centerVis(scope)"
                          type="text"
                          >选择奖品</el-button
                        >
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="name" label="奖品名称" min-width="200px">
                  <template slot-scope="scope">
                    <div>
                      <span
                        v-if="
                          scope.row.prizeType == 3 || scope.row.prizeType == 10
                        "
                        style="width: auto; white-space: normal"
                      >
                        {{ scope.row.title }}
                      </span>
                      <span v-else-if="scope.row.prizeType">{{
                        scope.row.prizeType | prizeType
                      }}</span>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column label="值" width="80" prop="price">
                </el-table-column>

                <el-table-column label="奖品总份数" width="180">
                  <!-- :disabled="isStartEdit" -->
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.prizeCount"
                      placeholder="请输入"
                      @input="
                        scope.row.prizeCount = getNumberData($event, 0, 1, 100)
                      "
                    ></el-input>
                  </template>
                </el-table-column>

                <el-table-column label="奖品展示图片" width="170">
                  <template slot-scope="scope">
                    <el-image
                      class="elImg"
                      :src="scope.row.logo"
                      fit="contain"
                      style="
                        width: 40px;
                        height: 40px;
                        background: #d9d9d9;
                        border-radius: 4px 4px 4px 4px;
                      "
                    >
                      <div slot="error" class="image-slot"></div>
                    </el-image>
                  </template>
                </el-table-column>

                <el-table-column label="">
                  <template slot-scope="scope">
                    <!-- <div
                      v-if="backgroundOpacity || activityData.isStart"
                      class="btn-wrap"
                    >
                      <div style="color: #909399; margin-right: 10px">
                        上传图片
                      </div>
                      <div
                        style="color: #909399"
                        v-if="scope.row.prizeType != 3"
                      >
                        重置
                      </div>
                    </div> -->
                    <div class="btn-wrap">
                      <!-- <el-upload
                        :disabled="activityData.isStart"
                        class="upload"
                        action="/api/image/upload"
                        :show-file-list="false"
                        :before-upload="beforeUpload2"
                        :on-success="
                          (file) => {
                            return handleUpload2(file, scope);
                          }
                        "
                      >
                        <el-button
                          :disabled="isStartEdit"
                          type="text"
                          class="text-btn"
                          style="margin-right: 10px"
                          >上传图片</el-button
                        >
                      </el-upload>
                      <el-button
                        :disabled="isStartEdit"
                        v-if="scope.row.prizeType != 3"
                        type="text"
                        class="text-btn"
                        @click="cleanData(scope.row)"
                        >重置</el-button
                      > -->

                     <div class="del_box" v-if="!activityData.isStart && !backgroundOpacity">
                        <div class="delQx" @click="deleteSetting(scope.$index)">
                          <img src="@/assets/images/btn_del.svg" alt="" />
                        </div>
                      </div> 
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <el-button
                @click="addSettingAll"
                :disabled="isStartEdit"
                type="primary"
                style="margin-top: 8px; width: auto"
              >
                添加奖项（{{ prizeSettingList.length }}/4）
              </el-button>
            </div>
          </el-form-item>

          <el-form-item label="曝光商品:" prop="exposure" class="zindexBox">
            <el-checkbox v-model="ruleForm.exposureSwitch">
              是否添加曝光商品
            </el-checkbox>
            <el-button
              style="width: 155px; margin: 0 15px"
              @click="exposureProducts"
              :disabled="ruleForm.exposureSwitch == false"
            >
              {{
                itemListFor.length != ""
                  ? "添加曝光商品" + "(" + itemListFor.length + "/20" + ")"
                  : "添加曝光商品"
              }}
            </el-button>
            <draggable
              v-if="itemListFor.length > 0"
              v-model="mainImagelist"
              chosen-class="chosen"
              :scroll="true"
              animation="150"
              force-fallback="true"
              @start="isDragging = true"
              @end="onEnd"
              style="
                margin-top: 10px;
                background: rgba(38, 112, 251, 0.06);
                padding: 10px 10px 0px 10px;
              "
            >
              <transition-group type="transition">
                <div
                  v-for="(item, index) in mainImagelist"
                  :key="item.skuId"
                  style="display: inline-block; position: relative"
                  class="show_upImg2"
                >
                  <img
                    :src="item.logo"
                    width="120px"
                    height="120px"
                    style="display: inline-block"
                  />&nbsp;
                  <div class="delectPosible">
                    <span class="delectSort">拖动排序</span>
                    <img
                      src="@/assets/thdImg/pages/delet.svg"
                      @click.stop="delec(item, index)"
                      class="delectIcom"
                    />
                  </div>
                </div>
              </transition-group>
            </draggable>
          </el-form-item>
          <el-form-item label="活动规则:" prop="ruleDescription">
            <div style="width: 500px; padding: 8px 0; position: relative">
              <!-- 淘宝v3.36 -->
              <div style="margin-top: -7px">
                <el-checkbox
                  v-model="activePage"
                  :disabled="backgroundOpacity"
                  @change="handleCheckAllChangeTaoBao"
                  style="float: left; line-height: 22px"
                  >活动规则是否展示活动页<el-tooltip
                    class="item"
                    effect="light"
                    content="选中即展示在活动页中间，用户可直观查看活动规则"
                    placement="bottom"
                  >
                    <el-button
                      type="text"
                      style="width: 35px; margin-left: -8px"
                    >
                      <i style="margin-top: -20px" class="el-icon-question"></i>
                    </el-button> </el-tooltip
                ></el-checkbox>
                <span> </span>
              </div>
              <!-- end -->
              <el-input
                type="textarea"
                class="textarea"
                style="width: 484px"
                resize="none"
                v-model="ruleForm.ruleDescription"
                :disabled="backgroundOpacity"
                :maxlength="2000"
              ></el-input>
              <div class="prosi" style="color: #909399">
                （{{
                  ruleForm.ruleDescription.length
                    ? ruleForm.ruleDescription.length - 1
                    : 0
                }}/2000）
              </div>
              <div>
                <el-button
                  type="primary"
                  class="generate"
                  plain
                  @click="generateRule"
                  :disabled="backgroundOpacity"
                >
                  生成规则
                </el-button>

                <span class="desc">
                  <i
                    class="el-alert__icon el-icon-info"
                    style="color: #999"
                  ></i>
                  点击按钮自动生成规则，也可以自己编辑信息
                </span>
              </div>
            </div>
          </el-form-item>

          <div v-if="backgroundOpacity" class="backgroundOpacity"></div>
        </el-form>
      </div>
    </div>
    <div class="create_bottom">
      <el-button
        class="createBtn create_bottom_returnBtn"
        size="medium"
        @click="clickLocalStep()"
        >{{ backgroundOpacity ? "返回列表" : "返回上一步" }}</el-button
      >
      <template v-if="!backgroundOpacity">
        <el-button
          v-if="isSave"
          class="createBtn create_bottom_keepBtn"
          type="primary"
          size="medium"
          @click="saveEdit"
          v-preventReClick
          >保存设置</el-button
        >
      </template>
    </div>

    <!-- 添加曝光商品 -->
    <selectGoodsMonitor
      v-if="selectGoodsState"
      @transferName="selectGoodsClose"
      :postForm="selectGoodsArr"
      :maxNum="20"
    >
    </selectGoodsMonitor>
    <!-- 保存并完成设置弹框 -->
    <el-dialog title="重要提示" :visible.sync="joinBlackList" width="800">
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="allowLevel"
        >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
      >
      <div slot="footer" class="dialog-footer">
        <el-button @click="joinBlackList = false">取 消</el-button>
        <el-button @click="handleDialogCloseAnoth()" type="primary"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <!-- 选择奖品弹窗 -->
    <selectProduct
      @close="colseDialog"
      :reShop="true"
      :num="1"
      :echoDate="echoDate"
      :JingdouCount="JingdouCount"
      v-if="showDialog"
      ref="selectProduct"
      @choose-shop="getTheData"
    >
    </selectProduct>

    <!-- 统一奖品弹窗 -->
    <select-Product
      @close="colseDialog1"
      :reShop="true"
      :num="1"
      :echoDate="echoDate1"
      :JingdouCount="JingdouCount1"
      v-if="showDialog1"
      ref="selectProduct1"
      @choose-shop="getTheData1"
    ></select-Product>
  </div>
</template>

<script>
import { getActivity, saveOrUpdate } from "@/api/integralCenter/birthdayGift";
import selectPrize from "./select_prize.vue";
import { querymemberLevel } from "@/api/integralCenter/memberLevel";
import selectProduct from "./select_product";

import selectGoodsMonitor from "@/components/selectGoodsMonitor";
import draggable from "vuedraggable";

export default {
  components: {
    selectProduct,
    selectPrize,
    selectGoodsMonitor,
    draggable,
  },
  computed: {
    // 获取选中的会员
    getChooseLevel() {
      if (this.ruleForm.partner.includes("-1")) {
        return this.levelList;
      } else {
        return this.levelList.filter((item) =>
          this.ruleForm.partner.includes(item.value)
        );
      }
    },
  },
  data() {
    return {
      JingdouCount: {
        prizeCount: 0,
      },
      JingdouCount1: {
        prizeCount: 0,
      },
      priceImg:
        "https://yunqi-taohd.oss-cn-hangzhou.aliyuncs.com/yunqihd_B/prizeShow.png", //默认产品图
      couponImg:
        "https://yunqi-taohd.oss-cn-hangzhou.aliyuncs.com/yunqihd_B/coupon.png",
      integralImg:
        "https://yunqi-taohd.oss-cn-hangzhou.aliyuncs.com/yunqihd_B/integral.png",
      levelIndex: 0,
      prizeSettingListLevel: [],
      echoDate: {},
      echoDate1: {},
      uploadSize3: false,
      activePage: false, //活动规则是否展示活动页
      peopleList: [],
      isStartEditTime: "",
      isStartEdit: false,
      valueRow: null,
      isCopy: false,
      activityData: {
        id: null,
      },
      backgroundOpacity: false,
      isSave: true,
      defaultTime: [
        this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length),
        this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length),
      ],
      activityTimeValue: this.$getDate(30),
      pickerOptionsValue: {
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 8.64e7 ||
            time.getTime() >
              new Date(this.$store.state.loginUserInfo.expiredIn).valueOf()
          );
        },
      },
      JingdouCount: {
        prizeCount: 0,
      },
      levelList: [], // 会员等级列表
      //每日签到
      checked: false,
      joinBlackList: false,
      draggingId: [], //有拖拽时要传的ID顺序
      mainImagelist: [], //图片拖拽排序
      isDragging: false,
      itemListFor: [], //商品弹框选择商品数据
      showDialog: false, // 选择奖品弹窗
      showDialog1: false, // 选择奖品弹窗
      selectGoodsState: false, // 曝光商品弹窗
      selectGoodsArr: [], // 曝光商品列表
      timeDay: 0, //活动持续天数
      timeOut: 0, //多少小时

      ruleForm: {
        membershipTime:"", // 入会时间
        activityName: "", // 活动名称
        startTime: "", //活动开始时间
        endTime: "", //活动结束时间
        allowLevel: ["-1"], // 会员等级
        activityObject: 0,
        newOldCustomer: 0,
        partner: ["-1"],
        prizeSetType: 1, // 奖品设置 1统一设置，2按等级设置
        exposureSwitch: false, // 是否添加曝光商品
        itemList: [], // 曝光商品集合
        ruleDescription: "", //生成规则
        birthBeforeDay: null, //生日前XX天
        birthAfterDay: null, //生日后XX天
        settingType: 2, //统一奖品设置
      },
      prizeSettingList: [
        {
          // 统一奖品参数
          price: null,
          title: "",
          assetsId: null,
          prizeType: null,
          logo: "",
          discount: "",
          prizeCount: null, // 奖品总份数
          singleAmount: "",
          prizeCount: "",
        },
      ],
      tableData: [
        // 梯度奖品参数
        {
          peopleCount: "",
          prizeType: "",
          discount: "",
          price: "",
          prizeCount: "",
          singleAmount: "",
          memberLevel: "0",
        },
      ],
      tableIndex: null,
      rules: {
        // 表单规则校验
        activityName: [
          { required: true, message: "请输入活动名称", trigger: "change" },
          {
            min: 3,
            max: 50,
            message: "长度在 3 到 50 个字符",
            trigger: "blur",
          },
        ],
        activityTimeValue: [
          { required: true, message: " ", trigger: "change" },
        ],
        ruleDescription: [
          { required: true, message: "请填写活动规则", trigger: "change" },
        ],
        allowLevel: [
          {
            type: "array",
            required: true,
            message: "至少选择一个",
            trigger: "change",
          },
        ],
      },
      generalCoupon: {
        // 通用优惠券
        couponType: 0,
      },
    };
  },
  async created() {
    this.activityData = this.$route.query.activityData;
    console.log("this.$route.query------>", this.$route.query);
    //获取会员
    let res = await querymemberLevel();
    if (res.code != 1) {
      return;
    }
    res.data.forEach((item, index) => {
      console.log('item',item);
      
      this.levelList.push({
        name: item.customerLevelName,
        value: String(item.customerLevel),
      });
    });
    // this.levelList.unshift({
    //   name: "非会员",
    //   value: 0,
    // });
    //加多一个二维数组
    this.prizeSettingListLevel = res.data.map((item) => {
      return {
        customerLevel: String(item.customerLevel),
        name: item.customerLevelName,
        settingList: [
          {
            // 统一奖品参数
            price: null,
            title: "",
            assetsId: null,
            prizeType: null,
            logo: "",
            discount: "",
            prizeCount: null, // 奖品总份数
            singleAmount: "",
            memberLevel: item.customerLevel,
          },
        ],
      };
    });
    // this.typeDetail();
    if (this.$route.query.valueRow || this.$route.query.copyParams) {
    } else {
      // this.tableData = this.levelList.map((item, index) => {
      //   return {
      //     peopleCount: "",
      //     prizeType: "",
      //     discount: "",
      //     price: "",
      //     prizeCount: "",
      //     singleAmount: "",
      //     memberLevel: item.level,
      //   };
      // });
    }
    if (this.$route.query.valueRow) {
      // 查看活动
      this.backgroundOpacity =
        this.$route.query.backgroundOpacity == "true" ? true : false;
      this.isSave = this.$route.query.isSave == "true" ? true : false;
      this.isStartEdit = this.$route.query.isStartEdit == "true" ? true : false;
      this.valueRow = this.$route.query.valueRow;
      this.typeDetail();
    } else if (this.$route.query.copyParams) {
      // 复制
      this.isCopy = true;
      this.backgroundOpacity = false;
      this.isSave = true;
      this.isStartEdit = false;
      this.valueRow = this.$route.query.copyParams.valueRow;
      this.typeDetail();
    } else {
      // 创建活动
      this.activityTimeChange();
    }
  },
  mounted() {
    this.mainImagelist = JSON.parse(sessionStorage.getItem("mainImagelist"));
  },
  filters: {
    prizeType(num) {
      let result = "";
      if (num == "1") {
        result = "优惠券";
      } else if (num == "3") {
        result = "实物";
      } else if (num == "4") {
        result = "店铺积分";
      } else if (num == "8") {
        result = "现金红包";
      } else if (num == "10") {
        result = "专属实物";
      }
      return result;
    },
  },
  methods: {
    // 删除
    deleteSetting(index, item) {
      // 会员
      if (item) {
        item.settingList.splice(index, 1);
      } else {
        this.prizeSettingList.splice(index, 1);
      }
    },
    // 添加奖项
    addSettingAll() {
      if (this.prizeSettingList.length > 3)
        return this.$message.warning("最多只能设置4个奖品");
      this.prizeSettingList.push({
        // 统一奖品参数
        price: null,
        title: "",
        assetsId: null,
        prizeType: null,
        logo: "",
        discount: "",
        prizeCount: null, // 奖品总份数
        singleAmount: "",
      });
    },
    //按等级设置添加奖项
    addSetting(item) {
      console.log(item,'656546546');
      
      if (item.settingList.length > 3)
      return this.$message.warning("最多只能设置4个奖品");
      item.settingList.push({
        // 统一奖品参数
        memberLevel: item.customerLevel,
        price: null,
        title: "",
        assetsId: null,
        prizeType: null,
        logo: "",
        discount: "",
        prizeCount: null, // 奖品总份数
        singleAmount: "",
      });
      console.log(item.settingList,'545554');
      
    },
    levelClick(index) {
      this.levelIndex = index;
    },
    //上传图片前校验   按阶级名次奖品图片设置
    beforeUpload3(file) {
      let _this = this;
      let image = new Image();
      let _URL = window.URL || window.webkitURL;
      image.onload = function () {
        console.log("宽高", image.width, image.height);
        const valid = image.width == 300 && image.height == 300;
        file.isFlag = valid;
        _this.uploadSize3 = valid;
        console.log(valid);
        if (valid) {
        } else {
          _this.$message.warning("图片宽高不符合要求,请重新上传");
          sizetype = false;
          return false;
        }
      };
      image.src = _URL.createObjectURL(file);
      console.log(file);
      const isLt3M = file.size < 1024 * 1024;
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"];
      let sizetype = false;
      if (!isLt3M) {
        this.$message.warning("上传图片大小不能超过 1MB");
        return false;
      }
      if (sorts.indexOf(type) < 0) {
        this.$message.info("所选文件格式不符，请重新选择");
        return false;
      }
    },
    // 上传成功  按阶级名次奖品图片设置
    handleUpload3(res, scope) {
      if (res.code != 1) {
        this.$message.error(res.messaga);
      } else {
        if (this.uploadSize3) {
          this.$set(scope.row, "logo", res.data);
        }
      }
    },
    // 上传成功  按阶级名次奖品图片设置
    handleUpload2(res, scope) {
      if (res.code != 1) {
        this.$message.error(res.messaga);
      } else {
        if (this.uploadSize) {
          this.$set(scope.row, "logo", res.data);
        }
      }
    },
    // 重置背景图  按阶级名次奖品图片设置
    picUrlReset3(scope) {
      this.$set(scope.row, "logo", this.priceImg);
    },
    //按阶梯删除
    deleteClass(index) {
      this.tableData.splice(index, 1);
    },
    // 按阶级新增
    addClass() {
      if (this.tableData.length === 4) {
        this.$message.warning("最多可设置4个阶梯区间");
        return;
      }
      this.tableData.push({
        // 统一奖品参数
        price: null,
        title: "",
        assetsId: null,
        prizeType: null,
        logo: "",
        discount: "",
        prizeCount: null, // 奖品总份数
        singleAmount: "",
      });
    },
    //活动规则页面
    handleCheckAllChangeTaoBao(val) {
      this.activePage = val
    },
    beforeUpload2(file) {
      let _this = this;
      const isSize = new Promise((resolve, reject) => {
        let width = 300;
        let height = 300;
        var _URL = window.URL || window.webkitURL;
        var img = new Image();
        img.onload = function () {
          let valid = width === this.width && height === this.height;
          valid ? resolve() : reject(this);
          _this.uploadSize = valid;
        };
        img.src = _URL.createObjectURL(file);
      }).then(
        () => {
          return file;
        },
        () => {
          this.$message.info("奖品展示图片尺寸不符合要求,请重新上传");
          return Promise.reject();
        }
      );
      // 校验尺寸和类型
      const isLt3M = file.size < 300 * 1024;
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"];
      const isType = sorts.includes(type);
      if (!isLt3M) {
        this.$message.info("奖品展示图片大小不符合要求,请重新上传");
      }
      if (!isType) {
        this.$message.info("奖品展示图片格式不符合要求,请重新上传");
      }
      return isLt3M && isType && isSize;
    },
    //回显
    typeDetail() {
      getActivity(this.valueRow.id)
        .then((res) => {
          let datas, change1, change2, days, daysStart, daysEnd, date3;
          daysStart = res.data.startTime.substring(0, 10);
          daysEnd = res.data.endTime.substring(0, 10);
          datas = daysEnd.split("-");
          change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
          datas = daysStart.split("-");
          change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
          days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);
          this.timeDay = days;
          //计算小时
          date3 =
            new Date(res.data.endTime).getTime() -
            new Date(res.data.startTime).getTime();
          let leave1 = date3 % (24 * 3600 * 1000);
          this.timeOut = Math.floor(leave1 / (3600 * 1000));
          this.activityTimeValue = [
            String(res.data.startTime),
            String(res.data.endTime),
          ];

          if (this.isStartEdit) {
            //进行中活动 无法修改活动开启时间
            this.isStartEditTime = String(res.data.startTime);
          }

          console.log("活动规则");
          // 活动规则赋值
          let { ruleDto, pointActivityPrizeDTOList } = res.data;
          let { birthBeforeDay, birthAfterDay, prizeSetType } = ruleDto;
          this.ruleForm.membershipTime = res.data.membershipTime
          this.ruleForm.birthBeforeDay = birthBeforeDay;
          this.ruleForm.birthAfterDay = birthAfterDay;
          this.ruleForm.prizeSetType = this.isCopy ? 1 : prizeSetType;

          this.ruleForm.activityName = res.data.activityName;
          this.ruleForm.startTime = String(res.data.startTime);
          this.ruleForm.endTime = String(res.data.endTime);
          this.ruleForm.activityObject = res.data.hasOwnProperty(
            "activityObject"
          )
            ? res.data.activityObject
            : 0;
          this.ruleForm.newOldCustomer = res.data.hasOwnProperty(
            "newOldCustomer"
          )
            ? res.data.newOldCustomer
            : 0;
          this.peopleList =
            res.data.hasOwnProperty("seniorGroupId") &&
            res.data.seniorGroupId.length > 0
              ? res.data.seniorGroupId.split(",")
              : [];

          if (res.data.allowLevel) {
            let allowLevelArr = res.data.allowLevel.split(",");
            allowLevelArr.forEach((item, index) => {
              if (item == "-1") {
                item = "-1";
              } else {
                item = Number(item);
              }
            });
            this.ruleForm.allowLevel = allowLevelArr;
          }
          this.ruleForm.ruleDescription = this.isCopy
            ? ""
            : String(res.data.ruleDescription); //生成规则
          // this.ruleForm.allowLevel = res.data.allowLevel.split(",");
       
          //是否展示活动规则
          this.activePage = res.data.isDisplayRule == 1?true:false;
          if (prizeSetType == 1) { //统一设置
            if (!this.isCopy) {
                 //等级回显
                this.ruleForm.settingType = res.data.ruleDto.prizeSetType==1?2:1
                this.prizeSettingList = res.data.pointActivityPrizeDTOList.map(item=>{
                item.prizeCount = item.totalAmount
                return {
                  ...item
               }
            })
            }
            this.checkListchange(this.ruleForm.partner);
          } else {
            if (!this.isCopy) {
              if(res.data.pointActivityPrizeDTOList && res.data.pointActivityPrizeDTOList.length){
                  // 全部
                  let levelArr = []
                  if(this.ruleForm.partner.includes("-1")){
                    levelArr = this.levelList
                  }else{
                    levelArr = this.levelList.filter(item=>this.ruleForm.partner.includes(item.value))
                  }
                  this.ruleForm.settingType = res.data.ruleDto.prizeSetType==1?2:1
                  this.prizeSettingListLevel = levelArr.map((item) => {
                    const obj = {
                      customerLevel:item.value,
                      name: item.name,
                      settingList: [],
                    }
                    res.data.pointActivityPrizeDTOList.forEach(list=>{
                      if(item.value == list.memberLevel){
                        obj.settingList.push({...list,prizeCount:list.totalAmount})
                      }
                    })
                    return obj
                  });
              }
            } else {
              this.checkListchange(this.ruleForm.partner);
            }
          }
          //曝光商品
          this.ruleForm.exposureSwitch =
            res.data.isExposureItem == 0 ? false : true;
          console.log(this.ruleForm.exposureSwitch);
          // 商品处理
          let shopList = res.data.itemList
            ? res.data.itemList.map((item) => {
                return {
                  ...item,
                  numIid: item.wareId,
                  itemTitle: item.title,
                  picUrl: item.logo,
                };
              })
            : [];
          this.selectGoodsArr = shopList;
          this.itemListFor = shopList;
          this.mainImagelist = shopList;

          this.activityTimeChange();
        })
        .catch(() => {});
    },

    // 活动进行中修改奖品数量
    beAdd(row, type = 1) {
      console.log("活动进行中修改奖品数量");
      if (this.isStartEdit) {
        if (row) {
          if (type == 1) {
            if (row.minNum && Number(row.totalAmount) < Number(row.minNum)) {
              row.totalAmount = row.minNum;
              this.$message.warning("为避免客诉，奖品数量不能小于之前哦~");
            }
          } else if (type == 2) {
            if (row.minNum && Number(row.prizeCount) < Number(row.minNum)) {
              row.prizeCount = row.minNum;
              this.$message.warning("为避免客诉，奖品数量不能小于之前哦~");
            }
          }
        } else {
          console.log(
            "this.prizeSettingList.totalAmount",
            this.prizeSettingList.totalAmount
          );
          console.log(
            "this.prizeSettingList.minNum",
            this.prizeSettingList.minNum,
            Number(this.prizeSettingList.totalAmount) <
              Number(this.prizeSettingList.minNum) &&
              this.prizeSettingList.minNum
          );
          if (
            Number(this.prizeSettingList.totalAmount) <
              Number(this.prizeSettingList.minNum) &&
            this.prizeSettingList.minNum
          ) {
            this.prizeSettingList.totalAmount = this.prizeSettingList.minNum;
            this.$message.warning("为避免客诉，奖品数量不能小于之前哦~");
          }
        }
      }
    },

    // 打开选择奖品弹窗
    centerVis(scope) {
      console.log("123123123213");
      this.tableIndex = scope.$index;
      this.JingdouCount.prizeCount = scope.row.prizeCount;
      this.echoDate = scope.row;
      this.showDialog = true;
      this.$nextTick(() => {
        this.$refs.selectProduct.openDialog();
        this.$refs.selectProduct.physicalGift(this.echoDate)
      });
    },
    centerVis2(scope) {
      this.tableIndex1 = scope.$index;
      this.JingdouCount1.prizeCount = scope.row.prizeCount;
      this.echoDate1 = scope.row;
      this.showDialog1 = true;
      this.$nextTick(() => {
        this.$refs.selectProduct1.openDialog();
        this.$refs.selectProduct1.physicalGift(this.echoDate1)
      });
    },

    // 关闭选择奖品
    colseDialog() {
      this.showDialog = false;
    },
    colseDialog1() {
      this.showDialog1 = false;
    },

    //选择奖品数据
    getTheData(data, prizeType) {
      this.showDialog = false;
      const prizeSetting = this.prizeSettingList[this.tableIndex];

      // 按阶梯
      prizeSetting.prizeType = prizeType;
      prizeSetting.price = data.discount || data.singleAmount;
      prizeSetting.singleAmount = data.singleAmount;
      prizeSetting.title = data.name || prizeType;
      prizeSetting.assetsId = Number(data.couponId);
      prizeSetting.logo = data.logo || this.priceImg;
      switch (prizeType) {
        case 1: // 优惠券
          prizeSetting.quota = data.quota;
          prizeSetting.couponType = data.couponType;
          prizeSetting.logo = this.couponImg;
          prizeSetting.assetsId = data.batchKey;
          break;
        case 3: // 实物
          prizeSetting.skuId = data.skuId;
          if (data.prizeRemarkType){
            prizeSetting.prizeRemarkType = data.prizeRemarkType;
            prizeSetting.receivePayment = data.receivePayment;
            prizeSetting.remarkActionType = data.remarkActionType;
            if (data.remarkActionType == "1") {
              prizeSetting.startCreateTradeTimeForManualLinkTrade = data.startCreateTradeTimeForManualLinkTrade;
              prizeSetting.endCreateTradeTimeForManualLinkTrade = data.endCreateTradeTimeForManualLinkTrade;
            } else {
              prizeSetting.tradeLimitTime = data.tradeLimitTime;
              prizeSetting.tradeLimitTimeUnit = data.tradeLimitTimeUnit;
            }
            prizeSetting.itemType = data.itemType;
            prizeSetting.tradeFlag = data.tradeFlag;
            prizeSetting.content = data.content;
            if (data.itemType) {
              const arr = data.goodsList.map((item) => item.wareId);
              prizeSetting.numIid = arr.join(",");
            } else {
              prizeSetting.numIid = "";
            }
          }
          break;
        case 4: // 积分
          prizeSetting.logo = this.integralImg;
          break;
        case 10: // 实物-专属下单
          prizeSetting.price = data.price;
          prizeSetting.assetsId = data.id;
          prizeSetting.title = data.itemTitle;
          prizeSetting.logo = data.picUrl;
          break;
      }
    },
    getTheData1(data, prizeType) {
      this.showDialog1 = false;
      // 按阶梯
      const setting =
        this.prizeSettingListLevel[this.levelIndex].settingList[
          this.tableIndex1
        ];
      setting.prizeType = prizeType;
      setting.price = data.discount || data.singleAmount;
      setting.singleAmount = data.singleAmount;
      setting.title = data.name || prizeType;
      setting.assetsId = Number(data.couponId);
      setting.logo = data.logo || this.priceImg;
      // 优惠券
      if (prizeType === 1) {
        setting.quota = data.quota;
        setting.couponType = data.couponType;
        setting.logo = this.couponImg;
        setting.assetsId = data.batchKey;
      }
      // 实物
      if (prizeType === 3) {
        setting.skuId = data.skuId;
        if (data.prizeRemarkType){
            setting.prizeRemarkType = data.prizeRemarkType;
            setting.receivePayment = data.receivePayment;
            setting.remarkActionType = data.remarkActionType;
            if (data.remarkActionType == "1") {
              setting.startCreateTradeTimeForManualLinkTrade = data.startCreateTradeTimeForManualLinkTrade;
              setting.endCreateTradeTimeForManualLinkTrade = data.endCreateTradeTimeForManualLinkTrade;
            } else {
              setting.tradeLimitTime = data.tradeLimitTime;
              setting.tradeLimitTimeUnit = data.tradeLimitTimeUnit;
            }
            setting.itemType = data.itemType;
            setting.tradeFlag = data.tradeFlag;
            setting.content = data.content;
            if (data.itemType) {
              const arr = data.goodsList.map((item) => item.wareId);
              setting.numIid = arr.join(",");
            } else {
              setting.numIid = "";
            }
          }
      }
      // 积分
      if (prizeType === 4) {
        setting.logo = this.integralImg;
      }
      // 实物-专属下单
      if (prizeType === 10) {
        setting.price = data.price;
        setting.assetsId = data.id;
        setting.title = data.itemTitle;
        setting.logo = data.picUrl;
      }
    },
    setPrizeTxt(item) {
      if (item.prizeType == 8) {
        item.prizeTxt = item.price + "元";
      } else {
        if (item.couponType == 4) {
          item.prizeTxt = item.price;
        } else {
          item.prizeTxt = item.singleAmount;
        }
      }
    },

    //清空统一奖品数据
    deleteCoupon() {
      this.prizeSettingList.price = null;
      this.prizeSettingList.title = "";
      this.prizeSettingList.assetsId = null;
      this.prizeSettingList.prizeType = null;
    },

    // 弹框确认
    handleDialogCloseAnoth() {
      this.ruleForm.startTime = this.activityTimeValue[0];
      this.ruleForm.endTime = this.activityTimeValue[1];
      //对象排序(根据对象的某一属性)
      // if (this.draggingId.length != []) {
      //   let a = this.draggingId;
      //   let b = [];
      //   for (let i = 0; i < a.length; i++) {
      //     this.itemListFor.find((obj) => {
      //       if (obj.skuId == a[i]) {
      //         b.push({
      //           logo: obj.logo,
      //           price: obj.price,
      //           title: obj.title,
      //           skuId: obj.skuId,
      //           wareId: obj.numIid,
      //         });
      //       }
      //     });
      //   }
      // }
      //活动名称的限制
      if (
        !this.ruleForm.activityName ||
        this.ruleForm.activityName.length == 0
      ) {
        this.$message.warning("请输入活动名称");
        return;
      }
      //活动时间的限制
      if (!this.ruleForm.startTime || !this.ruleForm.endTime) {
        this.$message.warning("请输入活动时间");
        return;
      }

      if (!this.ruleForm.ruleDescription) {
        this.$message.warning("活动规则不能为空");
        return;
      }

      //判断勾选提示后即可调取接口
      if (this.checked == true) {
        let {
          birthBeforeDay,
          birthAfterDay,
          prizeSetType,
          exposureSwitch,
          allowLevel,
          ...formParams
        } = this.ruleForm;
        let obj = {
          ...formParams,
          // allowLevel: allowLevel.join(","),
          activityObject: this.ruleForm.activityObject,
          membershipTime:this.ruleForm.membershipTime,
          isDisplayRule:this.activePage == false ? '0':'1',
          newOldCustomer: this.ruleForm.newOldCustomer,
          seniorGroupId: this.peopleList.join(","),
          allowLevel: this.ruleForm.allowLevel.join(","), //参与会员等级：-1(全部)，0(非会员)，其余填会员等级,
          isExposureItem: exposureSwitch ? 1 : 0,
          activityType: this.activityData.id, //活动类型
          ruleDTO: {
            birthBeforeDay,
            birthAfterDay,
            prizeSetType,
          },
          pointActivityPrizeDTOList: [],
          itemList: this.itemListFor.map((item) => {
            return {
              logo: item.logo,
              price: item.price,
              title: item.title,
              skuId: item.skuId,
              wareId: item.numIid,
            };
          }),
        };
        obj.ruleDTO.prizeSetType = this.ruleForm.settingType==2?1:2;
        //奖品设置传参
        if (this.ruleForm.settingType == 1) {
        // 如果 settingType 为 1，需要在这里添加相应的逻辑  
        this.prizeSettingListLevel.forEach(list => {
          list.settingList.forEach(item => {
           let prize = {
            title: item.title,
            assetsId: item.assetsId,
            prizeType: item.prizeType,
            logo: item.logo,
            discount: item.price || item.singleAmount,
            singleAmount: item.singleAmount,
            price: item.price,
            totalAmount: item.prizeCount, // 总数额
            memberLevel: Number(item.memberLevel),
        };
        if (prize.prizeType == 3) {
            prize.logo = item.logo;
            prize.assetsId = item.skuId || item.assetsId;
              //开启自定义信息
              let obj = {}
              if (item.prizeRemarkType == 1) {
                  obj.prizeRemarkType = item.prizeRemarkType;
                  obj.receivePayment =
                    item.receivePayment;
                  obj.tradeLimitTime =
                    item.tradeLimitTime;
                  obj.tradeLimitTimeUnit =
                    item.tradeLimitTimeUnit;
                  obj.itemType = item.itemType;
                  obj.tradeFlag = item.tradeFlag;
                  obj.content = item.content;
                  obj.numIid = item.numIid;
                  obj.remarkActionType = item.remarkActionType;
                  obj.startCreateTradeTimeForManualLinkTrade = item.startCreateTradeTimeForManualLinkTrade;
                  obj.endCreateTradeTimeForManualLinkTrade  = item.endCreateTradeTimeForManualLinkTrade;
                  prize.pointActivityPrizeRemark = obj
            }
        }
         if (prize.prizeType == 1) {
            prize.quota = item.quota;
            prize.couponType = item.couponType;
          }
         if (prize.prizeType == 2 || prize.prizeType == 4) {
            prize.singleAmount = item.price;
           } else {
            prize.singleAmount = 1;
           }
           obj.pointActivityPrizeDTOList.push(prize)
         });
         })
        } else {
          //统一设置
          obj.pointActivityPrizeDTOList = this.prizeSettingList.map((item) => {
            let prize = {
              title: item.title,
              assetsId: item.assetsId,
              prizeType: item.prizeType,
              logo: item.logo,
              discount: item.price || item.singleAmount,
              singleAmount: item.singleAmount,
              price: item.price,
              totalAmount: item.prizeCount, // 总数额
            };
            if (prize.prizeType == 3) {
              prize.logo = item.logo;
              prize.assetsId = item.skuId || item.assetsId;
              //开启自定义信息
              let obj = {}
              if (item.prizeRemarkType == 1) {
                  obj.prizeRemarkType = item.prizeRemarkType;
                  obj.receivePayment =
                    item.receivePayment;
                  obj.tradeLimitTime =
                    item.tradeLimitTime;
                  obj.tradeLimitTimeUnit =
                    item.tradeLimitTimeUnit;
                  obj.itemType = item.itemType;
                  obj.tradeFlag = item.tradeFlag;
                  obj.content = item.content;
                  obj.numIid = item.numIid;
                  obj.remarkActionType = item.remarkActionType;
                  obj.startCreateTradeTimeForManualLinkTrade = item.startCreateTradeTimeForManualLinkTrade;
                  obj.endCreateTradeTimeForManualLinkTrade  = item.endCreateTradeTimeForManualLinkTrade;
                  prize.pointActivityPrizeRemark = obj
              }
            }
            if (prize.prizeType == 1) {
              prize.quota = item.quota;
              prize.couponType = item.couponType;
            }
            if (prize.prizeType == 2 || prize.prizeType == 4) {
              prize.singleAmount = item.price;
            } else {
              prize.singleAmount = 1;
            }
            return prize; // 返回单个奖品对象
          });
        }
        //创建传模板id 
        if (this.$route.query.valueRow && !this.isCopy) {
          obj.id = this.valueRow.id;
        }else{
          obj.templateId = this.activityData.templateId;
        }
        //end
        saveOrUpdate(obj).then((res) => {
          console.log("保存活动", res);
          this.joinBlackList = false;
          if (res.code == 1) {
            this.$message.success(res.message);
            this.$router.push({ path: "activeList1" });
          } else {
            this.$message.error(res.message);
          }
        });
        return;
      } else {
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    //清除
    cleanData(row) {
      if (this.activityData.isStart || this.backgroundOpacity) return;
      row.assetsId = null;
      row.prizeType = null;
      row.price = null;
      row.title = null;
      row.logo = null;
      row.percentage = "";
      row.singleAmount = null;
      row.totalAmount = null;
    },

    // 活动时间驱动
    activityTimeChange(val) {
      if (this.isStartEdit) {
        //进行中活动 无法修改活动开启时间
        this.activityTimeValue[0] = this.isStartEditTime;
      }

      this.ruleForm.startTime = this.activityTimeValue[0];
      this.ruleForm.endTime = this.activityTimeValue[1];
      let nowTime = new Date().getTime();
      let start = new Date(this.ruleForm.startTime).valueOf();
      let end = new Date(this.ruleForm.endTime).valueOf();
      console.log("time", this.ruleForm.startTime, start);
      let invalidateDate = new Date(
        this.$store.state.loginUserInfo.expiredIn
      ).valueOf();

      var datas, change1, change2, days, daysStart, daysEnd, date3;
      daysStart = this.ruleForm.startTime.substring(0, 10);
      daysEnd = this.ruleForm.endTime.substring(0, 10);
      if (this.ruleForm.endTime != "" && this.ruleForm.startTime != "") {
        datas = daysEnd.split("-");
        change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        datas = daysStart.split("-");
        change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);

        if (days < 3 && !this.backgroundOpacity) {
          this.$message.warning("活动间隔最少为3天！");
          this.activityTimeValue[1] = "";
          this.ruleForm.endTime = null;
          this.timeOut = 0;
          this.timeDay = 0;
          return;
        }

        this.timeDay = days;
        //计算小时
        date3 =
          new Date(this.ruleForm.endTime).getTime() -
          new Date(this.ruleForm.startTime).getTime();
        var leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
      } else {
        this.timeOut = 0;
      }

      if (this.backgroundOpacity) return;
      if (end > invalidateDate) {
        this.$message.warning("活动时间不能超过软件有效期，请重新选择");
        this.activityTimeValue[1] = "";
        this.ruleForm.endTime = null;
        return;
      }
      if (!this.isStartEdit && (start - nowTime) / 1000 / 60 < 5) {
        this.$message.warning("活动时间开始时间要大于当前时间的5分钟");
      }
      if (end < nowTime) {
        this.$message.warning("结束时间不能小于当前时间");
      }
      if (end < start) {
        this.$message.warning("结束时间不能小于开始时间");
      }
    },

    // 保存编辑
    saveEdit() {
      let state = true;
      if (this.ruleForm.prizeSetType == 2) {
        let arr = this.tableData.map((i) => {
          return i.peopleCount;
        });
        let copyArr = JSON.parse(JSON.stringify(arr)).sort((a, b) => {
          return a - b;
        });
        for (let i = 0; i < arr.length; i++) {
          if (arr[i] != copyArr[i]) {
            state = false;
          }
        }
        if (!state) {
          return this.$message.error("邀请人数梯度不可大于上一个梯度1");
        }
      }
      this.joinBlackList = true;
    },
    // 下一步
    resetForm() {
      this.joinBlackList = true;
    },
    // 打开曝光商品弹窗
    exposureProducts() {
      this.selectGoodsState = true;
      // console.log(this.itemListFor);
      if (this.itemListFor.length == 0) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
      this.$refs.selectGo.handleRightCurrentChange(1);
    },
    // 选择曝光商品
    selectGoodsClose(event, index) {
      if (typeof event != "boolean") {
        let newArr = event;
        if (index && index == 1) {
          this.itemListFor = newArr;
          this.mainImagelist = newArr;
          this.selectGoodsArr = newArr;
        }
      }
      this.selectGoodsState = false;
    },
    // 删除曝光商品
    delec(item, index) {
      let i = "-1";
      this.mainImagelist.forEach((items, index1) => {
        if (items.skuId == item.skuId) i = index1;
      });
      console.log(i, 55555);
      if (i != "-1") {
        this.mainImagelist.splice(i, 1);
        this.itemListFor = this.mainImagelist;
      }
      console.log(this.mainImagelist, 4444444);
    },
    // 曝光商品图片拖拽结束
    onEnd() {
      this.isDragging = false;
      //拖拽完成后的顺序
      let arr = [];
      console.log("this.mainImagelist)", this.mainImagelist);
      this.mainImagelist.forEach((item) => {
        // arr.push(item.wareId);
        arr.push(item.skuId);
        // this.draggingId = arr;
      });
    },
    //会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          console.log("获取等级列表");
          res.data.forEach((item, index) => {
            console.log(item,'8888888888888888');
            
            this.levelList.push({
              name: item.customerLevelName,
              value: item.customerLevel,
            });
          });
          this.prizeSettingListLevel = res.data.map((item) => {
            return {
              customerLevel: String(item.customerLevel),
              name: item.customerLevelName,
              settingList: [
                {
                  price: null,
                  title: "",
                  assetsId: null,
                  prizeType: null,
                  logo: "",
                  discount: "",
                  prizeCount: null, // 奖品总份数
                  singleAmount: "",
                  memberLevel: item.level,
                },
              ],
            };
          });
        })
        .catch((res) => {});
    },
    //选中 全部会员 改变
    checkListchange(val) {
      // 重置选中状态
      this.levelIndex = 0;
      // 全部
      let levelArr = [];
      if (val.includes("-1")) {
        this.ruleForm.partner = ["-1"];
        levelArr = this.levelList;
      } else {
        levelArr = this.levelList.filter((item) => val.includes(item.value));
      }
      this.prizeSettingListLevel = levelArr.map((level) => {
        const index = this.prizeSettingListLevel.findIndex(
          (item) => item.customerLevel == level.value
        );
        console.log(index);
        // 已存在
        if (index != -1) {
          return this.prizeSettingListLevel[index];
        } else {
          return {
            customerLevel: level.value,
            name: level.name,
            settingList: [
              {
                memberLevel: level.value,
                price: null,
                title: "",
                assetsId: null,
                prizeType: null,
                logo: "",
                discount: "",
                prizeCount: null, // 奖品总份数
                singleAmount: "",
              },
            ],
          };
        }
      });
    },
    //生成规则
    generateRule() {
      let text1 = "",
        text2 = "";
      // //活动名称
      // if (this.ruleForm.activityName.length > 0) {
      //   text1 = "活动名称：" + this.ruleForm.activityName;
      // }
      //活动时间
      if (this.ruleForm.startTime && this.ruleForm.endTime) {
        text2 =
          "活动时间：" + this.ruleForm.startTime + "~" + this.ruleForm.endTime;
      }
      let text3 = "";
      //参与对象
      if (
        this.ruleForm.activityObject == "1" &&
        this.ruleForm.allowLevel.length > 0
      ) {
        let levelText = [];
        this.ruleForm.allowLevel.forEach((item) => {
          if (item == "-1") {
            item = "全部";
          }
          // else if (item == 0) {
          //   item = "非会员";
          // }
          else {
            this.levelList.forEach((it, index) => {
              if (it.level == item) {
                item = it.name;
              }
            });
          }
          levelText.push(item);
        });

        text3 = "活动参与对象：" + levelText.splice(",");
      } else {
        text3 = "活动参与对象：全部";
      }
      let text4 = "";
      if (this.ruleForm.activityObject == "1" && this.ruleForm.membershipTime && this.ruleForm.allowLevel!=[0]){
        text4 = `入会时间：${this.ruleForm.membershipTime}之后入会的会员可参与活动`
      }
      let text = "";
      let arr = [
        text2,
        text3,
        text4,
        "1.生日信息登记后不可更改，生日奖励1年只能领取1次;",
        "2.一旦发现活动参与者有使用脚本作弊、一人使用多个账户等违规及不正当行为，活动方有权取消该用户参与活动的资格，并冻结或取消已发放的奖励。 对情况恶劣者，活动方有权取消相关用户在平台参与奖励服务的资格。任何存在使用物联网卡或未实名卡， 或使用被任何平台或者第三方认定为或标记为黑产囤积号码、诈骗号码、羊毛党号码、异常号段号码、非实名用户等情形的用户，将被认定为非正常用户。 一旦认定为非正常用户活动方有权取消该用户的全部活动奖品/奖励，并保留追究法律责任的权利。",
        "活动最终解释权归店铺所有。",
      ];
      arr.forEach((item) => {
        if (item.length > 0) {
          text = text + item + "\n";
        }
      });
      this.ruleForm.ruleDescription = text;
      return;
      //活动规则判断,暂时保留，预防后续产品需要

      //活动名称
      if (this.ruleForm.activityName.length > 0) {
        text1 = "活动名称：" + this.ruleForm.activityName;
      }
      //活动时间
      if (this.ruleForm.startTime && this.ruleForm.endTime) {
        text2 =
          "活动时间：" + this.ruleForm.startTime + "~" + this.ruleForm.endTime;
      }
      //参与对象
      if (this.ruleForm.allowLevel.length > 0) {
        let levelText = [];
        this.ruleForm.allowLevel.forEach((item, index) => {
          if (item == -1) {
            item = "全部";
          } else {
            this.levelList.forEach((it, index) => {
              if (index == item) {
                item = it;
              }
            });
          }
          levelText.push(item);
        });
        text3 = "活动参与对象：" + levelText.splice(",");
      }

      let Arr1 = [text1, text2, text3];
      let newText = "";
      let newNum = 1;
      Arr1.forEach((item) => {
        if (item.length > 0) {
          newText = newText + newNum + "." + item + ";" + "\n";
          newNum = newNum + 1;
        }
      });
      this.ruleForm.ruleDescription = newText;
    },
    // 返回
    clickLocalStep() {
      sessionStorage.setItem("goBack", this.activityData.goIndex);
      if (this.$route.query.copyParams && this.$route.query.copyParams.isCopy) {
        sessionStorage.setItem("goBackCopy", true);
      }
      this.$router.go(-1);
    },
    handleActivityObj() {
      this.ruleForm.newOldCustomer = 0;
      this.ruleForm.allowLevel = ["-1"];
      this.peopleList = [];
    },
    filterLevel(level) {
      let target = this.levelList.find((item) => item.level == level);
      return target ? target.name : "";
    },
  },
};
</script>

<style lang="scss" scoped>
.text-btn {
  width: auto;
  padding: 0px !important;
  margin-right: 10px;
}
.prosi {
  position: absolute;
  bottom: 45px;
  right: 20px;
}
.desc {
  i {
    opacity: 0.7;
    color: #fe4d45;
  }
  color: #999;
}

.flex {
  display: flex;
  align-items: center;
}
.prize_box {
  padding: 26px 21px;
  background: #fcfcfc;
  .tips {
    width: 600px;
    display: flex;
    align-items: center;
    // align-items: flex-start;
    box-sizing: border-box;
    background: #fffaee;
    border-radius: 3px;
    font-size: 14px;
    font-weight: 400;
    color: #333;
    margin-bottom: 9px;
  }
  .add_btn {
    cursor: pointer;
    color: #2670fb;
    border: 1px dashed #2670fb;
    width: 520px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 8px;
  }
}
.createPlayStep {
  // min-width: 1360px;
  position: relative;
  box-sizing: border-box;
  // min-height: 80vh;
  height: 88.5vh;
  background-color: #fff;
  // box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  margin: 24px;

  .secondstep {
    // min-height: 870px;
    box-sizing: border-box;
    position: relative;
    padding: 0px 28px 1px 24px;
    // margin-bottom: 29px;
    .generate {
      width: 76px;
      margin: 8px 8px 0 0;
      background: rgba(38, 112, 251, 0.1);
      border: 1px solid #2670fb;
      color: #2670fb;
      border-radius: 4px;
    }
    .lastTime {
      margin-left: 20px;
      font-size: 14px;
      i {
        color: #ccc;
      }
    }
    .theLag {
      position: relative;
      margin-top: 10px;
      height: 142px;
      width: 302px;
      .theBox {
        height: 142px;
        width: 302px;
        // border: 1px solid #999;
        background: url("../../assets/thdImg/pages/yhq.svg") no-repeat;
        border-radius: 8px;
        position: absolute;
        color: #333333;
        margin-bottom: 10px;
        .discount_sty {
          font-family: DIN;
          font-weight: bold;
          color: #2670fb;
          font-size: 45px;
        }
        .pp {
          width: 280px;
          text-align: center;
          bottom: 0px;
        }
      }
      .btnQx {
        display: none;
      }
      &:hover {
        .btnQx {
          display: block;
          position: absolute;
          top: 50%;
          left: 50%;
          margin: -16px 0 0 -49px;
        }
        .backgrd {
          width: 100%;
          height: 100%;
          background: #fff;
          position: absolute;
          border-radius: 8px;
          opacity: 0.7;
        }
      }
    }
  }
}

//统一奖品设置
.setting-level {
  display: flex;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 10px;
  &-item {
    width: 125px;
    text-align: center;
    background-color: #e9effc;
    &__active {
      color: #fff;
      background-color: #2670FB;
    }
  }
}
//添加奖项
.add_btn1 {
  cursor: pointer;
  color: #2670fb;
  border: 1px solid #2670fb;
  width: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(123, 97, 255, 0.1);
  border-radius: 4px;
  margin-top: 8px;
}
.btnGroup1 {
  display: flex;
  align-items: center;
}
.btnGroup {
  display: flex;
  justify-content: space-around;
  align-items: center;
  &_button {
    color: #2670fb;
    cursor: pointer;
  }
}
.del_box {
  position: absolute;
  left: 65px;
  top: 15px;
  width: 50px;
  height: 50px;
}
.delQx {
  width: 25px;
  height: 25px;
  background: rgb(255, 76, 68) !important;
  display: inline-block;
  display: none;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  img {
    width: 50px;
    margin-right: 4px;
  }
  // display: none;
}
.btn-wrap {
  display: flex;
  align-items: center;
}
.add_btn1 {
  cursor: pointer;
  color: #7b61ff;
  border: 1px solid #7b61ff;
  width: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(123, 97, 255, 0.1);
  border-radius: 4px;
  margin-top: 8px;
}
.setting-tip-red {
  color: red;
}
/deep/ .el-table__row:hover {
  .delQx {
    display: flex;
  }
}
/deep/ .el-table__body-wrapper {
  overflow: visible !important;
}
</style>
